import { BRAND } from '../constants';

// All scoped CSS for the Transacting Users screen: card entrance animations,
// the live pulse dot, the modern table skin, and branded button/modal overrides.
export default function InsightStyles() {
    return (
        <style>{`
            @keyframes fadeInUp {
                from {
                    opacity: 0;
                    transform: translateY(10px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            @keyframes shimmer {
                0% {
                    background-position: -1000px 0;
                }
                100% {
                    background-position: 1000px 0;
                }
            }
            @keyframes livePulse {
                0% { transform: scale(1); opacity: 0.55; }
                70%, 100% { transform: scale(2.6); opacity: 0; }
            }
            .insight-hero {
                animation: fadeInUp 0.5s ease-out 0.1s both;
                position: relative;
            }
            .insight-hero::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 60%;
                height: 100%;
                background: linear-gradient(
                    90deg,
                    transparent,
                    rgba(255, 255, 255, 0.18),
                    transparent
                );
                animation: shimmer 3s infinite;
                pointer-events: none;
            }
            .insight-donut {
                animation: fadeInUp 0.5s ease-out 0.2s both;
            }
            .insight-hero:hover,
            .insight-donut:hover {
                transform: translateY(-2px);
                transition: transform 0.2s ease;
            }
            .insight-segments button:hover {
                background: rgba(26, 122, 126, 0.10);
                color: ${BRAND.tealDark};
            }
            .insight-segments button:hover:not(:disabled) {
                background: rgba(26, 122, 126, 0.10);
            }

            /* ── Modern, clean table (scoped to this screen) ── */
            .np-modern-table {
                animation: fadeInUp 0.5s ease-out 0.25s both;
                background: #fff;
                border: 1px solid #EEF2F3;
                border-radius: 16px;
                overflow: hidden;
                box-shadow: 0 8px 24px rgba(13, 82, 87, 0.05);
            }
            /* strip the old heavy grid / bordered look */
            .np-modern-table .ant-table {
                background: transparent;
                font-size: 13px;
            }
            .np-modern-table .ant-table.ant-table-bordered > .ant-table-container {
                border-inline-start: none !important;
            }
            .np-modern-table .ant-table-container,
            .np-modern-table .ant-table-container table > thead > tr:first-child > *:first-child { border-start-start-radius: 0; }
            .np-modern-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
            .np-modern-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th,
            .np-modern-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
            .np-modern-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td {
                border-inline-end: none !important;
            }
            .np-modern-table .ant-table-thead > tr > th {
                background: #F6FAFA !important;
                color: #5b7377 !important;
                font-weight: 700;
                font-size: 11px;
                text-transform: uppercase;
                letter-spacing: 0.04em;
                border-bottom: 1px solid #E7EFEF !important;
                padding: 12px 16px !important;
            }
            .np-modern-table .ant-table-thead > tr > th::before {
                display: none !important;
            }
            /* antd renders a hidden measure row for fixed columns — keep it collapsed */
            .np-modern-table .ant-table-measure-row {
                visibility: collapse;
            }
            .np-modern-table .ant-table-measure-row > td {
                padding: 0 !important;
                border: none !important;
                height: 0 !important;
            }
            .np-modern-table .ant-table-tbody > tr.ant-table-row > td {
                border-bottom: 1px solid #F2F5F5 !important;
                padding: 12px 16px !important;
                transition: background 0.16s ease;
            }
            .np-modern-table .ant-table-tbody > tr.ant-table-row:last-child > td {
                border-bottom: none !important;
            }
            .np-modern-table .ant-table-tbody > tr.ant-table-row {
                cursor: pointer;
            }
            .np-modern-table .ant-table-tbody > tr.ant-table-row:hover > td {
                background: ${BRAND.tealSoft} !important;
            }
            .np-modern-table .ant-table-cell-fix-left,
            .np-modern-table .ant-table-cell-fix-right {
                background: #fff !important;
            }
            .np-modern-table .ant-table-tbody > tr:hover .ant-table-cell-fix-left,
            .np-modern-table .ant-table-tbody > tr:hover .ant-table-cell-fix-right {
                background: ${BRAND.tealSoft} !important;
            }
            .np-modern-table .ant-pagination {
                padding: 14px 16px 4px;
                margin: 0 !important;
            }
            .np-modern-table .ant-pagination .ant-pagination-item {
                border-radius: 8px;
                border-color: #E7EFEF;
            }
            .np-modern-table .ant-pagination .ant-pagination-item-active {
                background: ${BRAND.tealDark};
                border-color: ${BRAND.tealDark};
            }
            .np-modern-table .ant-pagination .ant-pagination-item-active a {
                color: #fff;
                font-weight: 700;
            }
            .np-modern-table .ant-pagination .ant-pagination-item:hover {
                border-color: ${BRAND.teal};
            }
            .np-modern-table .ant-pagination .ant-pagination-item:hover a {
                color: ${BRAND.tealDark};
            }

            /* Override the global green .ant-btn-primary for our branded buttons */
            .np-primary-btn.ant-btn-primary,
            .np-suspend-modal .ant-btn-primary {
                background: ${BRAND.tealDark} !important;
                background-color: ${BRAND.tealDark} !important;
                border-color: ${BRAND.tealDark} !important;
                color: #fff !important;
                text-shadow: none !important;
                box-shadow: 0 4px 14px rgba(13, 82, 87, 0.28) !important;
            }
            .np-primary-btn.ant-btn-primary:hover,
            .np-primary-btn.ant-btn-primary:focus,
            .np-suspend-modal .ant-btn-primary:hover,
            .np-suspend-modal .ant-btn-primary:focus {
                background: ${BRAND.teal} !important;
                background-color: ${BRAND.teal} !important;
                border-color: ${BRAND.teal} !important;
            }

            /* Modern Suspend modal */
            .np-suspend-modal .ant-modal-content {
                border-radius: 18px;
                overflow: hidden;
                padding: 0;
                box-shadow: 0 24px 60px rgba(13, 82, 87, 0.22);
            }
            .np-suspend-modal .ant-modal-header {
                padding: 18px 28px;
                border-bottom: 1px solid #EEF3F3;
                margin-bottom: 0;
            }
            .np-suspend-modal .ant-modal-footer {
                padding: 16px 28px 22px;
                border-top: 1px solid #EEF3F3;
            }
            .np-suspend-modal .ant-modal-footer .ant-btn {
                border-radius: 10px !important;
                height: 42px !important;
                padding: 0 28px !important;
            }
            .np-suspend-modal .ant-modal-close {
                top: 14px;
                inset-inline-end: 16px;
            }

            /* Modern user details drawer */
            .np-user-drawer .ant-drawer-content {
                border-top-left-radius: 20px;
                border-bottom-left-radius: 20px;
                overflow: hidden;
            }
            .np-user-drawer .ant-drawer-body {
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
        `}</style>
    );
}
